export default "__VITE_ASSET___aF8NTXP__"